import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { buildersWithPhonesSelector, isLeadFactorySelector, sellersWithPhonesSelector } from '../../selectors';
import { TThunkDispatch } from '../../types/redux';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { ShowPhonesModal } from '../../components/MobileShowPhonesModal';
import { handleCall } from '../../actions/analytics/call';

interface IShowPhonesModalContainerProps {
  isModalOpen: boolean;
  closePhoneModal(): void;
}
export function ShowPhonesModalContainer(props: IShowPhonesModalContainerProps) {
  const dispatch = useDispatch<TThunkDispatch>();
  const builders = useSelector(buildersWithPhonesSelector);
  const sellers = useSelector(sellersWithPhonesSelector);

  const leadFactorySeller = useSelector(isLeadFactorySelector);

  const deviceType = useDeviceType();

  const onModalClose = React.useCallback(() => {
    props.closePhoneModal();
  }, [dispatch]);

  const trackActionCall = React.useCallback(
    (builder: INewbuildingBuilder) => {
      // звонок
      dispatch(handleCall(builder));
    },
    [dispatch],
  );

  /* istanbul ignore next */
  if (builders.length + sellers.length === 0 && !leadFactorySeller) {
    return null;
  }

  const moreThanOnePhone = builders.length + sellers.length > 1;

  if (moreThanOnePhone || deviceType === 'tablet' || !!leadFactorySeller) {
    return (
      <ShowPhonesModal
        isOpen={props.isModalOpen}
        placeType="main_button"
        builders={builders}
        sellers={sellers}
        leadFactorySeller={leadFactorySeller}
        trackActionCall={trackActionCall}
        onModalClose={onModalClose}
      />
    );
  }

  /* istanbul ignore next */
  return null;
}
